// Angular
import { Injectable } from '@angular/core';

// Third party
import { Observable } from 'rxjs';

// Local file
import { HttpService } from '../services';



// TODO: write tests
@Injectable()
export class JurisdictionAPIService {
  private readonly API_URL = '/api/Jurisdiction';

  constructor(
    private readonly httpService: HttpService,
  ) {}

  /**
   * GET API
   */

  /**
   * @description
   * Get a list of all current Jurisdictions and restrictions.
   *
   * @param country String
   * @returns Observable<unknown>
   */
  getJurisdictions$(country?: string): Observable<unknown> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetJurisdictions`,
      params: this.httpService.objToHttpParams({
        country
      })
    });
  }

  /**
   * @description
   * Get a specific Jurisidiction and restrictions.
   *
   * @param country string
   * @param subdivision string
   * @returns Observable<unknown>
   */
  getJurisdiction$(country: string, subdivision: string): Observable<unknown> {
    return this.httpService.get$({
      api: `${this.API_URL}/GetJurisdiction`,
      params: this.httpService.objToHttpParams({
        country,
        subdivision
      })
    });
  }

}
